import { useState } from "react";
import clsx from "clsx";
import { MoreVert } from "@mui/icons-material";
import { makeStyles } from "@mui/styles";
import { SummaryPopover } from "./SummaryPopover";

import { palette } from "../../../theme/palette";

import { View } from "../../Base";

const useStyles = makeStyles(() => ({
  container: {
    display: "flex",
    alignItems: "center",
  },
  moreIcon: {
    cursor: "pointer",
  },
  fillOrange: {
    fill: palette.orange,
  },
}));

const MoreInfoComponent = ({ waveMode }) => {
  const styles = useStyles();

  const [moreAnchorEl, setMoreAnchorEl] = useState(null);

  return (
    <View className={styles.container}>
      <MoreVert
        className={clsx(
          styles.moreIcon,
          moreAnchorEl ? styles.fillOrange : null
        )}
        onClick={(event) => {
          setMoreAnchorEl(event.currentTarget);
        }}
      />
      <SummaryPopover
        open={!!moreAnchorEl}
        onClose={() => setMoreAnchorEl(null)}
        anchorEl={moreAnchorEl}
        waveMode={waveMode}
      />
    </View>
  );
};

export default MoreInfoComponent;
